import { jsxs, jsx } from "react/jsx-runtime";
import { ModalBase } from "./ModalBase.js";
function Modal({
  isOpen,
  onClose,
  size,
  isCloseButtonHidden,
  isClosedOnOverlayClick,
  title,
  secondaryInfo,
  additionalActions,
  thumbnail,
  children,
  actionPrimary,
  actionSecondary,
  actionTertiary,
  container,
  onCloseAnimationEnd,
  sidebar,
  ...props
}) {
  return /* @__PURE__ */ jsxs(ModalBase, {
    isOpen,
    onClose,
    isClosedOnOverlayClick,
    isCloseButtonHidden,
    size,
    onCloseAnimationEnd,
    container,
    ...props,
    children: [/* @__PURE__ */ jsx(ModalBase.Header, {
      title,
      secondaryInfo,
      thumbnail,
      additionalActions
    }), sidebar ? /* @__PURE__ */ jsx(ModalBase.Sidebar, {
      children: sidebar
    }) : null, /* @__PURE__ */ jsx(ModalBase.Content, {
      children
    }), actionPrimary && /* @__PURE__ */ jsx(ModalBase.Footer, {
      actionPrimary,
      actionSecondary,
      actionTertiary
    })]
  });
}
export {
  Modal
};
//# sourceMappingURL=Modal.js.map
